export default __webpack_public_path__ + "static/media/pin-bl.186ef139.svg";